import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { Box, Container, Stack} from '@mui/material';
// config
import { NAV } from '../../config-global';
// sections
import AccountMenu from './AccountMenu';

// ----------------------------------------------------------------------

AccountLayout.propTypes = {
  children: PropTypes.node,
};

export default function AccountLayout({ children }) {
  return (
    <Container>
      <Stack
        direction={{
          md: 'row',
        }}
        alignItems={{
          md: 'flex-start',
        }}
        sx={{
          mb: {
            xs: 8,
            md: 10,
          },
        }}
      >
        <AccountMenu />

        <Box
          sx={{
            flexGrow: 1,
            pl: { md: 8 },
            width: { md: `calc(100% - ${NAV.W_DRAWER}px)` },
          }}
        >
          {children}
        </Box>
      </Stack>
    </Container>
  );
}
